import React from 'react';
import { Box, Container, Paper } from '@mui/material';
import { layoutPaddingY } from './layoutSpacing';

const SubscriptionLayout = ({ children }) => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f7fb', py: layoutPaddingY }}>
      <Container maxWidth="sm">
        <Paper elevation={2} sx={{ p: { xs: 3, sm: 4 }, borderRadius: 2 }}>
          {children}
        </Paper>
      </Container>
    </Box>
  );
};

export default SubscriptionLayout;
